import React from 'react';
import yaml from 'js-yaml';
// renderers is imported separately so Markdoc isn't sent to the client
import Markdoc, {renderers} from '@markdoc/markdoc'

import {getSchema} from '/vercel/path0/node_modules/@markdoc/next.js/src/runtime.js';
/**
 * Schema is imported like this so end-user's code is compiled using build-in babel/webpack configs.
 * This enables typescript/ESnext support
 */
const config = {};
import * as tags from '/vercel/path0/markdoc/tags.js'
import * as nodes from '/vercel/path0/markdoc/nodes.js'
const functions = {};
const schema = {
tags: tags ? (tags.default || tags) : {},
nodes: nodes ? (nodes.default || nodes) : {},
functions: functions ? (functions.default || functions) : {},
...(config ? (config.default || config) : {}),
};

/**
 * Source will never change at runtime, so parse happens at the file root
 */
const source = "---\ntitle: Creating an AI Teams Bot\npageTitle: Creating Teams bots - Mendable\ndescription: Creating Teams bots with Mendable.\n---\n\n## Use our Premade Microsoft Teams Bot\nYou can access any Mendable project in Microsoft Teams with this bot. This is a great way to quickly test and show off your Mendable bot!\n\nTo configure the bot, you need to set which Mendable API key you want to use. The Anon Key is the bridge between your Mendable project and the Teams platform, ensuring secure, personalized, and transparent interactions for your users. You can find your anon key on the project dashboard in the API Keys tab.\n\nTo make the app available to users in your organization's app store, follow these steps:\n\n1. Download the [Mendable Teams Bot](/mendable-teams-bot.zip) app package.\n\n2. Access Teams admin center and go to Teams apps > [Manage apps](https://admin.teams.microsoft.com/policies/manage-apps).\n\n3. On Actions menu, select Upload new app. ![](/images/teams-instructions-1.png)\n  \n4. Click on Upload, and select the app package you downloaded on  step 1, the name of the package is `mendable-teams-bot.zip`. ![](/images/teams-instructions-2.png)\n\n5. Make sure that the app is available for the organization's Teams users. ![](/images/teams-instructions-3.png)\n\n## Configure the Mendable Anon Key\n1. Access the project dashboard https://www.mendable.ai/\n2. Go to the API Keys page and copy the Client-side (ANON) key you want to use on Teams.\n3.  Send a message to the Mendable Bot app with the following command:\n```\nMendable API Anon Key: YOUR_ANON_API_KEY\n```\n\n\n## Features\n- The bot provides sources for its answers, ensuring transparency and verifiability of information.\n\n";
const filepath = "/integrations/teams.md";
const ast = Markdoc.parse(source);

/**
 * Like the AST, frontmatter won't change at runtime, so it is loaded at file root.
 * This unblocks future features, such a per-page dataFetchingFunction.
 */
const frontmatter = ast.attributes.frontmatter
  ? yaml.load(ast.attributes.frontmatter)
  : {};

const {components, ...rest} = getSchema(schema)

export async function getStaticProps(context) {
  const partials = {};

  // Ensure Node.transformChildren is available
  Object.keys(partials).forEach((key) => {
    partials[key] = Markdoc.parse(partials[key]);
  });

  const cfg = {
    ...rest,
    variables: {
      ...(rest ? rest.variables : {}),
      // user can't override this namespace
      markdoc: {frontmatter},
      // Allows users to eject from Markdoc rendering and pass in dynamic variables via getServerSideProps
      ...(context.variables || {})
    },
    partials,
    source,
  };

  /**
   * transform must be called in dataFetchingFunction to support server-side rendering while
   * accessing variables on the server
   */
  const content = Markdoc.transform(ast, cfg);

  return {
    // Removes undefined
    props: JSON.parse(
      JSON.stringify({
        markdoc: {
          content,
          frontmatter,
          file: {
            path: filepath
          }
        },
      })
    ),
  };
}

export default function MarkdocComponent(props) {
  // Only execute HMR code in development
  return renderers.react(props.markdoc.content, React, {
    components: {
      ...components,
      // Allows users to override default components at runtime, via their _app
      ...props.components,
    },
  });
}
